  $('.review_left').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.review_right'
});
$('.review_right').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.review_left',
  dots: true,
  pauseOnHover: true,
  pauseOnFocus: true,
  arrows:true
});
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#Huratips-Pagination'
  });
});